import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import {
  DELETE_BIDDER,
  DELETE_BIDDER_ERROR,
  DELETE_BIDDER_SUCCESS,
  GET_BIDDER_LIST,
  GET_BIDDER_LIST_ERROR,
  GET_BIDDER_LIST_SUCCESS,
  UPDATE_BIDDER,
  UPDATE_BIDDER_ERROR,
  UPDATE_BIDDER_SUCCESS,
  GET_BIDDER_DETAIL,
  GET_BIDDER_DETAIL_SUCCESS,
  GET_BIDDER_DETAIL_ERROR,
  CREATE_BEHALF_BID_PROPOSAL,
  CREATE_BEHALF_BID_PROPOSAL_SUCCESS,
  CREATE_BEHALF_BID_PROPOSAL_ERROR,
} from './actions';
import { BiddersAction, BiddersState, BidderStatus } from './types';

const initialState: BiddersState = {
  bidders: {
    loading: false,
    data: null,
    error: null,
  },
  bidder: {
    loading: false,
    data: null,
    error: null,
  },
};

const bidders = createReducer<BiddersState, BiddersAction>(initialState, {
  [GET_BIDDER_LIST]: (state) => ({
    ...state,
    bidders: {
      loading: true,
      error: null,
      data: null,
    },
  }),

  [GET_BIDDER_LIST_SUCCESS]: (state, action) => ({
    ...state,
    bidders: {
      loading: false,
      error: null,
      data: action.payload,
    },
  }),
  [GET_BIDDER_LIST_ERROR]: (state, action) => ({
    ...state,
    bidders: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [UPDATE_BIDDER]: (state) =>
    produce(state, (draft) => {
      draft.bidder.loading = true;
      draft.bidder.error = null;
    }),
  [UPDATE_BIDDER_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      /**
       * 공급 업체 선정 시 업체 리스트의 상태를 변경한다.
       * 공급 업체 선정 시 이미 선정된 업체가 존재한다면 해당 업체의 상태를 미선정으로 변경한다.
       */
      if (draft.bidder.data !== null && draft.bidders.data !== null) {
        const index: number = draft.bidders.data.findIndex(
          (bidder) => bidder.id === action.payload.id,
        );

        const awardedBidderIndex: number = draft.bidders.data.findIndex(
          (bidder) => bidder.status === BidderStatus.AWARDED,
        );

        if (index !== -1) {
          draft.bidders.data[index].status = action.payload.status;
        }

        if (awardedBidderIndex !== -1) {
          draft.bidders.data[awardedBidderIndex].status =
            BidderStatus.NOT_AWARDED;
        }
      }
      draft.bidder.data = action.payload;
      draft.bidder.loading = false;
      draft.bidder.error = null;
    }),
  [UPDATE_BIDDER_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.bidder.loading = false;
      draft.bidder.error = action.payload;
    }),

  [DELETE_BIDDER]: (state) =>
    produce(state, (draft) => {
      draft.bidders.loading = true;
      draft.bidders.error = null;
    }),
  [DELETE_BIDDER_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      if (draft.bidders.data !== null) {
        const index = draft.bidders.data.findIndex(
          (bidder) => bidder.id === action.payload,
        );
        draft.bidders.data.splice(index, 1);
      }
      draft.bidders.loading = false;
      draft.bidders.error = null;
    }),
  [DELETE_BIDDER_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.bidders.loading = false;
      draft.bidders.error = action.payload;
    }),

  [GET_BIDDER_DETAIL]: (state) => ({
    ...state,
    bidder: {
      loading: true,
      error: null,
      data: null,
    },
  }),

  [GET_BIDDER_DETAIL_SUCCESS]: (state, action) => ({
    ...state,
    bidder: {
      loading: false,
      error: null,
      data: action.payload,
    },
  }),
  [GET_BIDDER_DETAIL_ERROR]: (state, action) => ({
    ...state,
    bidder: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [CREATE_BEHALF_BID_PROPOSAL]: (state) =>
    produce(state, (draft) => {
      draft.bidder.loading = true;
      draft.bidder.error = null;
    }),
  [CREATE_BEHALF_BID_PROPOSAL_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      if (draft.bidder.data !== null && draft.bidders.data !== null) {
        const index: number = draft.bidders.data.findIndex(
          (bidder) => bidder.id === action.payload.id,
        );

        if (index !== -1) {
          draft.bidders.data[index].status = action.payload.status;
          if (
            action.payload.bidChance !== undefined &&
            action.payload.bidChance !== null &&
            action.payload.bidChance.bidProposals.length > 0
          ) {
            draft.bidders.data[index].recentAmount =
              action.payload.bidChance.bidProposals[
                action.payload.bidChance.bidProposals.length - 1
              ].amount;
          }
        }
      }
      draft.bidder.data = action.payload;
      draft.bidder.loading = false;
      draft.bidder.error = null;
    }),
  [CREATE_BEHALF_BID_PROPOSAL_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.bidder.loading = false;
      draft.bidder.error = action.payload;
    }),
});

export default bidders;
